import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { authHeader } from "@/lib/aadhaar";

export const LIVE_ONLY = ["Live classes are available only for enrolled students. Please enroll to access live sessions.",
  "लाइव क्लास केवल एनरोल्ड छात्रों के लिए हैं। लाइव सेशन के लिए कृपया एनरोल करें।"];

let cache = { key: null, at: 0, p: null };
const fetchRole = () => {
  const token = localStorage.getItem("rs_student_token") || "";
  if (cache.key === token && cache.p && Date.now() - cache.at < 60000) return cache.p;
  const p = token ? api.get("/aiot/access", authHeader("student")).then((r) => r.data.role).catch(() => "guest") : Promise.resolve("guest");
  cache = { key: token, at: Date.now(), p };
  return p;
};

// "guest" (not signed in) / "demo" (signed in, not approved) / "enrolled" (approved AIoT student); null while loading.
export const useClassRole = () => {
  const { pathname } = useLocation();
  const [role, setRole] = useState(null);
  useEffect(() => {
    let on = true;
    fetchRole().then((r) => on && setRole(r));
    return () => { on = false; };
  }, [pathname]);
  return role;
};
